import { render } from "./FormNotice2.vue?vue&type=template&id=259ef2fa&scoped=true"
import script from "./FormNotice2.vue?vue&type=script&lang=js"
export * from "./FormNotice2.vue?vue&type=script&lang=js"

import "./FormNotice2.vue?vue&type=style&index=0&id=259ef2fa&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/osod-form/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259ef2fa"]])

export default __exports__